import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import { Route } from "src/config/routes";
import styles from "src/screens/communicationSettings/CommunicationSettings.module.css";

const AssignmentAndVisaSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { navStore } = useContext(RootStoreContext);

    return (
        <UI.Row>
            <UI.Col md={12}>
                <UI.Card
                    title={t("screens.communication_settings.krediflow.assignment_and_visa.title").toString()}
                    className={styles.SettingsContainer}
                >
                    <UI.Row className="mb-3">
                        <UI.Col>
                            <h6 className="bold-text" style={{ color: "var(--primary)" }}>
                                {t("screens.communication_settings.krediflow.assignment_and_visa.standard.subtitle")}
                            </h6>
                            <span>
                                {t(
                                    "screens.communication_settings.krediflow.assignment_and_visa.standard.explanation_text"
                                )}
                            </span>
                            {navStore.hasFeatureKrediFlowPro ? (
                                <div className="mt-2">
                                    <span>
                                        {t(
                                            "screens.communication_settings.krediflow.assignment_and_visa.standard.pro_text"
                                        )}
                                    </span>
                                    <br />
                                    <br />
                                    <Link to={Route.krediflowConfigurationSettings}>
                                        {t(
                                            "screens.communication_settings.krediflow.assignment_and_visa.standard.visa_workflow_link"
                                        )}
                                    </Link>
                                </div>
                            ) : (
                                <div className="mt-2">
                                    <span>
                                        {t(
                                            "screens.communication_settings.krediflow.assignment_and_visa.standard.basic_text"
                                        )}
                                    </span>
                                </div>
                            )}
                        </UI.Col>
                    </UI.Row>
                    <hr />
                    {navStore.hasFeatureKrediFlowPro && (
                        <UI.Row className="mb-3">
                            <UI.Col>
                                <h6 className="bold-text" style={{ color: "var(--primary)" }}>
                                    {t(
                                        "screens.communication_settings.krediflow.assignment_and_visa.alternative.subtitle"
                                    )}
                                </h6>
                                <span>
                                    {t(
                                        "screens.communication_settings.krediflow.assignment_and_visa.alternative.explanation_text"
                                    )}
                                </span>
                                <>
                                    <br />
                                    <br />
                                    <Link to={Route.krediflowConfigurationSettings}>
                                        {t(
                                            "screens.communication_settings.krediflow.assignment_and_visa.alternative.alternative_assignment_link"
                                        )}
                                    </Link>
                                </>
                            </UI.Col>
                        </UI.Row>
                    )}
                </UI.Card>
            </UI.Col>
        </UI.Row>
    );
};

export const AssignmentAndVisaSettings = withRouter(Sentry.withProfiler(observer(AssignmentAndVisaSettingsBase)));
